import { css, cx } from "@emotion/css";
import { createHook } from "reakit-system";
import type { SystemStyleObject } from "@styled-system/css";
import { css as scss } from "@styled-system/css";
import type { BoxHTMLProps } from "reakit";
import type { Theme } from "@mos-cat/ds-theme";
import { useTheme } from "./useTheme";

export type StylesOptions = {
  /**
   * Дополнительные стили компонента. Важно! Хотя в этих стилях допускается использовать токены дизайн-системы, это не даёт гарантии что при обновлении библиотеки компонетов ничего не разъедется.
   * Использовать с осторожностью!
   */
  styles?: SystemStyleObject;
};

/**
 * Позволяет задавать компоненту любые стили.
 * Необходимо использовать с осторожностью - эти стили не являются частью дизайн-системы и при обновлениях компонентов могут приводить к непредсказуемому результату
 */
export const useStyles = createHook<StylesOptions, BoxHTMLProps>({
  keys: ["styles"],
  compose: [useTheme],
  useProps(options, props) {
    if (!options.styles) return props;
    return {
      ...props,
      className: cx(props.className, css(scss(options.styles || {})(options as { theme: Theme }))),
    };
  },
});
